import React, { useEffect } from "react"
import {useLocation, useNavigate, useRouteError} from "react-router-dom"
import {isPathHandlingNeeded, pathHandler} from "../../utils/handlers";

const ProtectedRoute = (props) => {

    const location = useLocation();
    const navigate = useNavigate()
    const isSignedIn = localStorage.getItem('isSignedIn')




    useEffect(() => {
        // if(isPathHandlingNeeded(location)){
        //     console.log("ProtectedRoute is called", isPathHandlingNeeded(location))
        //     navigate(pathHandler(location))
        // }
        navigate(pathHandler(location))
    }, [isSignedIn]);


    return (
        <React.Fragment>
                {isSignedIn ? props.children : null}
        </React.Fragment>
    )
}
export default ProtectedRoute